import React from "react";

const DashboardSkeleton: React.FC = () => {
  return (
    <div className="w-full font-outfit animate-pulse">
      <div className="w-full lg:w-[830px] mx-auto px-[16px] lg:px-0">
        <div className="h-8 bg-gray-2s00 rounded-md w-64 mb-8"></div>

        {/* Overview Card Skeleton */}
        <div className="bg-white grid grid-cols-1 md:grid-cols-3 my-[40px] rounded-[24px] border border-gray-200">
          <div className="flex flex-col justify-between">
            <div className="p-[32px]">
              <div className="h-5 bg-gray-200 rounded-md w-32 mb-3"></div>
              <div className="h-8 bg-gray-200 rounded-md w-40"></div>
            </div>
            <div className="border-[0.5px] border-gray-200"></div>
            <div className="p-[32px]">
              <div className="h-5 bg-gray-200 rounded-md w-48 mb-3"></div>
              <div className="h-8 bg-gray-200 rounded-md w-40"></div>
            </div>
          </div>

          <div className="bg-gray-100 md:col-span-2 rounded-r-[24px] p-[32px]">
            <div className="h-5 bg-gray-200 rounded-md w-40 mb-6"></div>
            <div className="flex justify-between mb-4">
              <div>
                <div className="h-4 bg-gray-200 rounded-md w-32 mb-2"></div>
                <div className="h-7 bg-gray-200 rounded-md w-32"></div>
              </div>
              <div>
                <div className="h-4 bg-gray-200 rounded-md w-32 mb-2"></div>
                <div className="h-7 bg-gray-200 rounded-md w-32"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Beneficiary Skeleton */}
        {[1].map((item) => (
          <div key={item} className="mb-12">
            <div className="my-12 flex justify-between items-center">
              <div className="h-6 bg-gray-200 rounded-md w-48"></div>
              <div className="h-10 bg-gray-200 rounded-md w-40"></div>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-3 gap-5">
              <div className="flex flex-col justify-between border rounded-xl bg-white p-[16px] lg:py-8">
                <div className="h-5 bg-gray-200 rounded-md w-32 mb-3"></div>
                <div className="h-8 bg-gray-200 rounded-md w-40"></div>
              </div>

              <div className="border rounded-xl bg-gray-100 py-8 px-5 lg:col-span-2">
                <div className="h-5 bg-gray-200 rounded-md w-64 mb-5"></div>
                <div className="flex justify-between items-center mb-3">
                  <div className="h-6 bg-gray-200 rounded-md w-20"></div>
                  <div className="h-5 bg-gray-200 rounded-md w-48 hidden lg:block"></div>
                </div>
                <div className="w-full h-2 bg-gray-200 rounded-full"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardSkeleton;
